import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ru from './locales/ru.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';

export const SUPPORTED_LANGUAGES = ['en', 'ru', 'ko', 'zh'];
export const DEFAULT_LANGUAGE = 'en';

// Custom path detector - reads language from URL path
const pathDetector = {
  name: 'path',
  lookup() {
    const path = window.location.pathname;
    const pathParts = path.split('/').filter(Boolean);

    if (pathParts.length > 0 && SUPPORTED_LANGUAGES.includes(pathParts[0])) {
      return pathParts[0];
    }
    return null;
  },
  cacheUserLanguage(lng) {
    // Save to localStorage
    localStorage.setItem('crypnal_language', lng);
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      ko: { translation: ko },
      zh: { translation: zh }
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false // React already does escaping
    },
    detection: {
      // Order of detection methods
      order: ['path', 'localStorage', 'navigator'],
      // Custom detectors
      lookupLocalStorage: 'crypnal_language',
      caches: ['localStorage'],
      // Add custom path detector
      detectors: [pathDetector]
    },
    react: {
      useSuspense: false // Disable suspense for SSR compatibility
    }
  });

export default i18n;
